/**
 * Forms Index Route
 *
 * Path: /_authenticated/forms/
 * Renders the Forms gallery (FormsPage). System requisitions + the user's
 * own custom uploads.
 */

import { createFileRoute } from '@tanstack/react-router';
import { FormsPage } from '../../pages/Forms/FormsPage';

const FormsIndexRouteComponent = () => {
  return <FormsPage />;
};

export const Route = createFileRoute('/_authenticated/forms/')({
  component: FormsIndexRouteComponent,
});
